<template>
  <div>
    <ModalEmbed
      @change="onChange"
      ref="modal-embed"
      @watch-next="$emit('watch-next')"
      @watch-previous="$emit('watch-previous')"
      v-on:points-change="$emit('points-change')"
    />
    <b-card no-body img-top class="media-card" @click="openModal">
      <b-card-img
        class="media-card__img"
        :src="'https://drive.google.com/thumbnail?id=' + file.id_google_drive"
      />
      <b-card-body class="media-card__body" :style="bodyStyle">
        <div class="media-card__head">
          <span class="media-card__title">{{ file.post_text }}</span>
          <span class="media-card__rate" :style="rateStyle">
            <v-icon name="star" />
            {{ file.rate }} / 5
          </span>
        </div>
        <div class="media-card__tags" v-if="file.subtags && file.subtags.length">
          <b-badge
            pill
            v-for="(subtag, i) in file.subtags"
            :key="'subtag-' + i"
            class="media-card__tag"
            :style="tagStyle"
            @click.stop="$emit('addSubtag', subtag.text)"
            >{{ subtag.text }}</b-badge
          >
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>
<script>
import ModalEmbed from "../modals/ModalEmbed";

// Cohesive brand palette; each card gets a stable accent derived from its id.
const PALETTE = [
  "#f8ac04",
  "#20b2aa",
  "#c6588d",
  "#e84756",
  "#208ac6",
  "#b76629",
  "#7b5ea7",
];

export default {
  components: {
    ModalEmbed,
  },
  props: ["file", "index", "watchIndex"],
  computed: {
    accent() {
      const key = String(this.file.id || "");
      let h = 0;
      for (let i = 0; i < key.length; i++) h = (h * 31 + key.charCodeAt(i)) >>> 0;
      return PALETTE[h % PALETTE.length];
    },
    bodyStyle() {
      return { backgroundColor: this.accent + "14" };
    },
    rateStyle() {
      return { color: this.accent };
    },
    tagStyle() {
      return { backgroundColor: this.accent, color: "#fff" };
    },
  },
  methods: {
    openModal() {
      this.$refs["modal-embed"].open({
        index: this.index,
        openUrl: this.file.view_link,
        title: this.file.short_name,
        stars: this.file.rate,
        fileid: this.file.id,
        subtags: this.file.subtags,
      });
    },
    onChange: function (index, rate) {
      this.$emit("change", index, rate);
    },
  },
  watch: {
    watchIndex() {
      if (this.watchIndex === this.index) {
        this.openModal();
      } else {
        this.$refs["modal-embed"].close();
      }
    },
  },
};
</script>

<style lang="scss">
.media-card {
  max-width: 20rem;
  border: none;
  border-radius: 18px;
  overflow: hidden;
  cursor: pointer;
  box-shadow: 0 6px 18px rgba(26, 35, 50, 0.08);
  transition: transform 0.18s ease, box-shadow 0.18s ease;
}
.media-card:hover {
  transform: translateY(-4px) scale(1.03);
  box-shadow: 0 16px 36px rgba(26, 35, 50, 0.18);
}
.media-card__img {
  border-radius: 0;
}
.media-card__body {
  padding: 14px 16px;
}
.media-card__head {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 8px;
}
.media-card__title {
  font-weight: 600;
  font-size: 0.9rem;
  line-height: 1.2;
  color: #1a2332;
}
.media-card__rate {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  gap: 3px;
  font-weight: 700;
  font-size: 0.75rem;
  padding: 3px 9px;
  border-radius: 999px;
  background: #ffffff;
  box-shadow: 0 1px 4px rgba(26, 35, 50, 0.12);
}
.media-card__tags {
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.media-card__tag {
  border: none;
  font-weight: 600;
  font-size: 0.72rem;
  padding: 5px 10px;
  cursor: pointer;
  transition: filter 0.12s ease;
}
.media-card__tag:hover {
  filter: brightness(0.95);
}
</style>
